// deps
import { defineMessage } from "react-intl";

// Types

/** Équipements intérieurs */
export const ROOM_FEATURE_TYPE_VALUE_EQUIPMENT_INDOOR = "ei";
/** Équipements extérieurs */
export const ROOM_FEATURE_TYPE_VALUE_EQUIPMENT_OUTDOOR = "eo";
/** Centres d'intérêts */
export const ROOM_FEATURE_TYPE_VALUE_INTEREST = "in";
/** Services */
export const ROOM_FEATURE_TYPE_VALUE_SERVICE = "se";
/** Caractéristiques */
export const ROOM_FEATURE_TYPE_VALUE_FEATURE = "fe";
/** Thématiques */
export const ROOM_FEATURE_TYPE_VALUE_THEME = "th";
/** Zone touristique */
export const ROOM_FEATURE_TYPE_VALUE_TOURIST_AREA = "ta";
/** Qualifications internes */
export const ROOM_FEATURE_TYPE_VALUE_QUALIFICATION_INT = "qi";
/** Services externes */
export const ROOM_FEATURE_TYPE_VALUE_SERVICE_EXT = "sx";
/** Activités externes */
export const ROOM_FEATURE_TYPE_VALUE_ACTIVITY_EXT = "ax";
/** Offres */
export const ROOM_FEATURE_TYPE_VALUE_OFFER = "of";

export const ROOM_FEATURE_TYPES = {
  [ROOM_FEATURE_TYPE_VALUE_EQUIPMENT_INDOOR]: {
    id: ROOM_FEATURE_TYPE_VALUE_EQUIPMENT_INDOOR,
    label: "équipements intérieurs",
    position: 1,
  },
  [ROOM_FEATURE_TYPE_VALUE_EQUIPMENT_OUTDOOR]: {
    id: ROOM_FEATURE_TYPE_VALUE_EQUIPMENT_OUTDOOR,
    label: "équipements extérieurs",
    position: 2,
  },
  [ROOM_FEATURE_TYPE_VALUE_INTEREST]: {
    id: ROOM_FEATURE_TYPE_VALUE_INTEREST,
    label: "centres d'intérêts",
    position: 3,
  },
  [ROOM_FEATURE_TYPE_VALUE_SERVICE]: {
    id: ROOM_FEATURE_TYPE_VALUE_SERVICE,
    label: "services proposés",
    position: 4,
  },
  [ROOM_FEATURE_TYPE_VALUE_FEATURE]: {
    id: ROOM_FEATURE_TYPE_VALUE_FEATURE,
    label: "caractéristiques",
    position: 5,
  },
  [ROOM_FEATURE_TYPE_VALUE_THEME]: {
    id: ROOM_FEATURE_TYPE_VALUE_THEME,
    label: "séjours à thème",
    position: 6,
  },
  [ROOM_FEATURE_TYPE_VALUE_QUALIFICATION_INT]: {
    id: ROOM_FEATURE_TYPE_VALUE_QUALIFICATION_INT,
    label: "agréments et qualifications nationales",
    position: 7,
  },
  [ROOM_FEATURE_TYPE_VALUE_SERVICE_EXT]: {
    id: ROOM_FEATURE_TYPE_VALUE_SERVICE_EXT,
    label: "services extérieurs",
    position: 8,
  },
  [ROOM_FEATURE_TYPE_VALUE_ACTIVITY_EXT]: {
    id: ROOM_FEATURE_TYPE_VALUE_ACTIVITY_EXT,
    label: "activités",
    position: 9,
  },
  [ROOM_FEATURE_TYPE_VALUE_OFFER]: {
    id: ROOM_FEATURE_TYPE_VALUE_OFFER,
    label: "offres promotionnelles",
    position: 10,
  },
  [ROOM_FEATURE_TYPE_VALUE_TOURIST_AREA]: {
    id: ROOM_FEATURE_TYPE_VALUE_TOURIST_AREA,
    label: "zones touristiques",
    position: 11,
  },
};

export const ROOM_FEATURE_TYPE_INTL_MESSAGES = {
  byValue: {
    [ROOM_FEATURE_TYPE_VALUE_EQUIPMENT_INDOOR]: {
      label: defineMessage({
        defaultMessage: "équipements intérieurs",
        description: "Type de fonctionnalité d’hébergement",
      }),
    },
    [ROOM_FEATURE_TYPE_VALUE_EQUIPMENT_OUTDOOR]: {
      label: defineMessage({
        defaultMessage: "équipements extérieurs",
        description: "Type de fonctionnalité d’hébergement",
      }),
    },
    [ROOM_FEATURE_TYPE_VALUE_INTEREST]: {
      label: defineMessage({
        defaultMessage: "centres d'intérêts",
        description: "Type de fonctionnalité d’hébergement",
      }),
    },
    [ROOM_FEATURE_TYPE_VALUE_SERVICE]: {
      label: defineMessage({
        defaultMessage: "services proposés",
        description: "Type de fonctionnalité d’hébergement",
      }),
      frontLabel: defineMessage({
        defaultMessage: "services",
        description:
          "type de fonctionnalité d’hébergement affiché pour les voyageurs",
      }),
    },
    [ROOM_FEATURE_TYPE_VALUE_FEATURE]: {
      label: defineMessage({
        defaultMessage: "caractéristiques",
        description: "Type de fonctionnalité d’hébergement",
      }),
    },
    [ROOM_FEATURE_TYPE_VALUE_THEME]: {
      label: defineMessage({
        defaultMessage: "séjours à thème",
        description: "Type de fonctionnalité d’hébergement",
      }),
    },
    [ROOM_FEATURE_TYPE_VALUE_QUALIFICATION_INT]: {
      label: defineMessage({
        defaultMessage: "agréments et qualifications nationales",
        description: "Type de fonctionnalité d’hébergement",
      }),
    },
    [ROOM_FEATURE_TYPE_VALUE_SERVICE_EXT]: {
      label: defineMessage({
        defaultMessage: "services extérieurs",
        description: "Type de fonctionnalité d’hébergement",
      }),
    },
    [ROOM_FEATURE_TYPE_VALUE_ACTIVITY_EXT]: {
      label: defineMessage({
        defaultMessage: "activités",
        description: "Type de fonctionnalité d’hébergement",
      }),
    },
    [ROOM_FEATURE_TYPE_VALUE_OFFER]: {
      label: defineMessage({
        defaultMessage: "offres promotionnelles",
        description: "Type de fonctionnalité d’hébergement",
      }),
    },
    [ROOM_FEATURE_TYPE_VALUE_TOURIST_AREA]: {
      label: defineMessage({
        defaultMessage: "zones touristiques",
        description: "Type de fonctionnalité d’hébergement",
      }),
      frontLabel: defineMessage({
        defaultMessage: "secteurs touristiques",
        description:
          "type de fonctionnalité d’hébergement affiché pour les voyageurs",
      }),
    },
  },
};

export const ROOM_FEATURE_TYPE_LIST = Object.values(ROOM_FEATURE_TYPES);
